import React, {useContext, useMemo} from "react";

import CameraFilterContext from "../../CameraListing/CameraFilterContext";
import t from "../../../../lib/translate";

import * as styles from "./activeFilterOptions.module.less";

export function ActiveFilterOptions() {
    const {active, resetAction, removeFilterAction} =
        useContext(CameraFilterContext);

    const activeOptions = useMemo(
        () =>
            active.reduce((optionList, {key, options}) => {
                return [
                    ...optionList,
                    ...options.reduce(
                        (optionListPerKey, {label}) => [
                            ...optionListPerKey,
                            {key, label}
                        ],
                        []
                    )
                ];
            }, []),
        [active]
    );

    return (
        <>
            {activeOptions.length !== 0 && (
                <div className={styles.resetButtonWrap}>
                    <button
                        className={styles.resetButton}
                        onClick={resetAction}
                    >{t`camera.filter.reset-button`}</button>
                    {activeOptions.map(({key, label}) => (
                        <button
                            key={`${key}-${label}`}
                            className={styles.activeOptionButton}
                            onClick={() => removeFilterAction(key)}
                        >
                            {label}
                        </button>
                    ))}
                </div>
            )}
        </>
    );
}
